import React from 'react';
import { connect } from 'react-redux';

import DeindexationStatusEnum from 'redpoints-model-js/enumeration/DeindexationStatusEnum';

import { TreeSelector } from 'redpoints-front-components/index';

import { allIncidentsFiltersSetDeindexation } from '../../../actions/allIncidentsActions';
import { getAllIncidentsFiltersDeindexationSelected } from '../../../reducers/reporting/allIncidents';
import { translate } from '../../../helpers/languageHelper';

const TREE_DATA = [
  {
    children: [
      {
        title: translate(DeindexationStatusEnum.REQUEST_CREATED.literalKey),
        value: DeindexationStatusEnum.REQUEST_CREATED.name,
      },
      {
        title: translate(DeindexationStatusEnum.REQUEST_ERROR.literalKey),
        value: DeindexationStatusEnum.REQUEST_ERROR.name,
      },
      {
        title: translate(DeindexationStatusEnum.REQUEST_APPROVED.literalKey),
        value: DeindexationStatusEnum.REQUEST_APPROVED.name,
      },
      {
        title: translate(DeindexationStatusEnum.REJECTED.literalKey),
        value: DeindexationStatusEnum.REJECTED.name,
      },
      {
        title: translate(DeindexationStatusEnum.DEINDEXED.literalKey),
        value: DeindexationStatusEnum.DEINDEXED.name,
      },
    ],
    title: translate('deindexationOptions.requested'),
    value: true,
  },
  {
    title: translate('deindexationOptions.nonrequested'),
    value: false,
  },
];

const AllIncidentsFiltersDeIndexationStatus = ({
  allIncidentsFiltersSetDeindexation,
  deindexationSelected,
}) => {
  const handleOnFilterChange = deindexation => {
    allIncidentsFiltersSetDeindexation({ deindexation });
  };

  return (
    <TreeSelector
      allowClear
      aria-label="deindexation-status"
      label={translate(
        'reporting.allIncidentsInternal.filters.deIndexationStatus'
      )}
      onChange={handleOnFilterChange}
      placeholder={translate('common.all')}
      treeData={TREE_DATA}
      value={deindexationSelected || undefined}
    />
  );
};

const mapStateToProps = state => ({
  deindexationSelected: getAllIncidentsFiltersDeindexationSelected(state),
});

export default connect(mapStateToProps, {
  allIncidentsFiltersSetDeindexation,
})(AllIncidentsFiltersDeIndexationStatus);
